/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.donations.controllers', [])

.controller('DonationsController', ['$scope', function($scope) {

    $scope.donations = {

      model: "Your spankin new application.donations view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.donations.init();

}]);